export default {"src":"/_next/static/media/SendConfirmation.85520909.svg","height":394,"width":413};